var _defs, _polygon, _g, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOrbis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 137.4 65.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #106aad;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-136 {\r\n        clip-path: url(#clippath-73);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #1070b7;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #0078be;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #008bce;\r\n      }\r\n\r\n      .cls-137 {\r\n        clip-path: url(#clippath-72);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #08c;\r\n      }\r\n\r\n      .cls-138 {\r\n        clip-path: url(#clippath-62);\r\n      }\r\n\r\n      .cls-139 {\r\n        clip-path: url(#clippath-186);\r\n      }\r\n\r\n      .cls-140 {\r\n        clip-path: url(#clippath-45);\r\n      }\r\n\r\n      .cls-141 {\r\n        clip-path: url(#clippath-63);\r\n      }\r\n\r\n      .cls-142 {\r\n        clip-path: url(#clippath-188);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #0375bc;\r\n      }\r\n\r\n      .cls-143 {\r\n        clip-path: url(#clippath-170);\r\n      }\r\n\r\n      .cls-144 {\r\n        clip-path: url(#clippath-20);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #0275bc;\r\n      }\r\n\r\n      .cls-145 {\r\n        clip-path: url(#clippath-135);\r\n      }\r\n\r\n      .cls-146 {\r\n        clip-path: url(#clippath-11);\r\n      }\r\n\r\n      .cls-147 {\r\n        clip-path: url(#clippath-123);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #0091d3;\r\n      }\r\n\r\n      .cls-148 {\r\n        clip-path: url(#clippath-16);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #00a2e1;\r\n      }\r\n\r\n      .cls-149 {\r\n        clip-path: url(#clippath-157);\r\n      }\r\n\r\n      .cls-150 {\r\n        clip-path: url(#clippath-59);\r\n      }\r\n\r\n      .cls-151 {\r\n        clip-path: url(#clippath-78);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #106db2;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #0475bc;\r\n      }\r\n\r\n      .cls-152 {\r\n        clip-path: url(#clippath-169);\r\n      }\r\n\r\n      .cls-153 {\r\n        clip-path: url(#clippath-93);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #0f64a4;\r\n      }\r\n\r\n      .cls-154 {\r\n        clip-path: url(#clippath-158);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #0e609e;\r\n      }\r\n\r\n      .cls-155 {\r\n        clip-path: url(#clippath-89);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #0f69ab;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #0e62a0;\r\n      }\r\n\r\n      .cls-156 {\r\n        clip-path: url(#clippath-33);\r\n      }\r\n\r\n      .cls-157 {\r\n        clip-path: url(#clippath-64);\r\n      }\r\n\r\n      .cls-158 {\r\n        clip-path: url(#clippath-47);\r\n      }\r\n\r\n      .cls-159 {\r\n        clip-path: url(#clippath-94);\r\n      }\r\n\r\n      .cls-160 {\r\n        clip-path: url(#clippath-77);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #0974bb;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #106db1;\r\n      }\r\n\r\n      .cls-161 {\r\n        clip-path: url(#clippath-162);\r\n      }\r\n\r\n      .cls-162 {\r\n        clip-path: url(#clippath-121);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #009ddd;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #0096d7;\r\n      }\r\n\r\n      .cls-163 {\r\n        clip-path: url(#clippath-160);\r\n      }\r\n\r\n      .cls-164 {\r\n        clip-path: url(#clippath-116);\r\n      }\r\n\r\n      .cls-165 {\r\n        clip-path: url(#clippath-161);\r\n      }\r\n\r\n      .cls-166 {\r\n        clip-path: url(#clippath-151);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #00a9e7;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #00a6e5;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #008fd1;\r\n      }\r\n\r\n      .cls-167 {\r\n        clip-path: url(#clippath-136);\r\n      }\r\n\r\n      .cls-168 {\r\n        clip-path: url(#clippath-132);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #0e619e;\r\n      }\r\n\r\n      .cls-169 {\r\n        clip-path: url(#clippath-41);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #0f65a6;\r\n      }\r\n\r\n      .cls-170 {\r\n        clip-path: url(#clippath-32);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #007bc1;\r\n      }\r\n\r\n      .cls-171 {\r\n        clip-path: url(#clippath-108);\r\n      }\r\n\r\n      .cls-172 {\r\n        clip-path: url(#clippath-163);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #106fb5;\r\n      }\r\n\r\n      .cls-173 {\r\n        clip-path: url(#clippath-112);\r\n      }\r\n\r\n      .cls-174 {\r\n        clip-path: url(#clippath-87);\r\n      }\r\n\r\n      .cls-175 {\r\n        clip-path: url(#clippath-142);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #007ac0;\r\n      }\r\n\r\n      .cls-176 {\r\n        clip-path: url(#clippath-173);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #0f73ba;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #0092d4;\r\n      }\r\n\r\n      .cls-177 {\r\n        clip-path: url(#clippath-83);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: #0087ca;\r\n      }\r\n\r\n      .cls-178 {\r\n        clip-path: url(#clippath-128);\r\n      }\r\n\r\n      .cls-179 {\r\n        clip-path: url(#clippath-119);\r\n      }\r\n\r\n      .cls-180 {\r\n        clip-path: url(#clippath-114);\r\n      }\r\n\r\n      .cls-181 {\r\n        clip-path: url(#clippath-185);\r\n      }\r\n\r\n      .cls-182 {\r\n        clip-path: url(#clippath-105);\r\n      }\r\n\r\n      .cls-183 {\r\n        clip-path: url(#clippath-2);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #0095d6;\r\n      }\r\n\r\n      .cls-184 {\r\n        clip-path: url(#clippath-13);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: #0e64a3;\r\n      }\r\n\r\n      .cls-185 {\r\n        clip-path: url(#clippath-88);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: #0088cb;\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: #00a5e4;\r\n      }\r\n\r\n      .cls-186 {\r\n        clip-path: url(#clippath-115);\r\n      }\r\n\r\n      .cls-187 {\r\n        clip-path: url(#clippath-182);\r\n      }\r\n\r\n      .cls-188 {\r\n        clip-path: url(#clippath-124);\r\n      }\r\n\r\n      .cls-189 {\r\n        clip-path: url(#clippath-37);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: #008acd;\r\n      }\r\n\r\n      .cls-190 {\r\n        clip-path: url(#clippath-46);\r\n      }\r\n\r\n      .cls-191 {\r\n        clip-path: url(#clippath-25);\r\n      }\r\n\r\n      .cls-192 {\r\n        clip-path: url(#clippath-98);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: #009cdc;\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: #0c73bb;\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: #00a8e6;\r\n      }\r\n\r\n      .cls-193 {\r\n        clip-path: url(#clippath-172);\r\n      }\r\n\r\n      .cls-194 {\r\n        clip-path: url(#clippath-107);\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: #0090d1;\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: #008bcd;\r\n      }\r\n\r\n      .cls-195 {\r\n        clip-path: url(#clippath-164);\r\n      }\r\n\r\n      .cls-196 {\r\n        clip-path: url(#clippath-15);\r\n      }\r\n\r\n      .cls-197 {\r\n        clip-path: url(#clippath-6);\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: #007dc3;\r\n      }\r\n\r\n      .cls-198 {\r\n        clip-path: url(#clippath-153);\r\n      }\r\n\r\n      .cls-199 {\r\n        clip-path: url(#clippath-104);\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: #00abe9;\r\n      }\r\n\r\n      .cls-200 {\r\n        clip-path: url(#clippath-76);\r\n      }\r\n\r\n      .cls-201 {\r\n        clip-path: url(#clippath-40);\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: #009ada;\r\n      }\r\n\r\n      .cls-202 {\r\n        clip-path: url(#clippath-117);\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: #0098d8;\r\n      }\r\n\r\n      .cls-203 {\r\n        clip-path: url(#clippath-26);\r\n      }\r\n\r\n      .cls-204 {\r\n        clip-path: url(#clippath-81);\r\n      }\r\n\r\n      .cls-205 {\r\n        clip-path: url(#clippath-111);\r\n      }\r\n\r\n      .cls-206 {\r\n        clip-path: url(#clippath-181);\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: #0094d5;\r\n      }\r\n\r\n      .cls-207 {\r\n        clip-path: url(#clippath-75);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: #0f6aac;\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-208 {\r\n        clip-path: url(#clippath-189);\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: #0081c6;\r\n      }\r\n\r\n      .cls-209 {\r\n        clip-path: url(#clippath-167);\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: #1070b6;\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: #008dcf;\r\n      }\r\n\r\n      .cls-210 {\r\n        clip-path: url(#clippath-7);\r\n      }\r\n\r\n      .cls-211 {\r\n        clip-path: url(#clippath-21);\r\n      }\r\n\r\n      .cls-212 {\r\n        clip-path: url(#clippath-130);\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: #0082c6;\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: #106cb0;\r\n      }\r\n\r\n      .cls-213 {\r\n        clip-path: url(#clippath-34);\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: #0f66a7;\r\n      }\r\n\r\n      .cls-214 {\r\n        clip-path: url(#clippath-176);\r\n      }\r\n\r\n      .cls-215 {\r\n        clip-path: url(#clippath-57);\r\n      }\r\n\r\n      .cls-216 {\r\n        clip-path: url(#clippath-102);\r\n      }\r\n\r\n      .cls-217 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: #00b0ec;\r\n      }\r\n\r\n      .cls-218 {\r\n        clip-path: url(#clippath-4);\r\n      }\r\n\r\n      .cls-219 {\r\n        clip-path: url(#clippath-138);\r\n      }\r\n\r\n      .cls-220 {\r\n        clip-path: url(#clippath-38);\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: #0079bf;\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: #007ec3;\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: #0d5f9c;\r\n      }\r\n\r\n      .cls-221 {\r\n        clip-path: url(#clippath-36);\r\n      }\r\n\r\n      .cls-222 {\r\n        clip-path: url(#clippath-127);\r\n      }\r\n\r\n      .cls-223 {\r\n        clip-path: url(#clippath-27);\r\n      }\r\n\r\n      .cls-224 {\r\n        clip-path: url(#clippath-125);\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: #0099d9;\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: #00a4e3;\r\n      }\r\n\r\n      .cls-225 {\r\n        clip-path: url(#clippath-109);\r\n      }\r\n\r\n      .cls-226 {\r\n        isolation: isolate;\r\n        opacity: .3;\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: #0f65a4;\r\n      }\r\n\r\n      .cls-227 {\r\n        clip-path: url(#clippath-149);\r\n      }\r\n\r\n      .cls-228 {\r\n        clip-path: url(#clippath-141);\r\n      }\r\n\r\n      .cls-229 {\r\n        clip-path: url(#clippath-101);\r\n      }\r\n\r\n      .cls-230 {\r\n        clip-path: url(#clippath-60);\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: #0081c5;\r\n      }\r\n\r\n      .cls-231 {\r\n        clip-path: url(#clippath-168);\r\n      }\r\n\r\n      .cls-232 {\r\n        clip-path: url(#clippath-44);\r\n      }\r\n\r\n      .cls-233 {\r\n        clip-path: url(#clippath-154);\r\n      }\r\n\r\n      .cls-234 {\r\n        clip-path: url(#clippath-122);\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: #008ed0;\r\n      }\r\n\r\n      .cls-63 {\r\n        fill: #0774bc;\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: #007cc2;\r\n      }\r\n\r\n      .cls-235 {\r\n        clip-path: url(#clippath-139);\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: #007fc4;\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: #007cc1;\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: #0097d8;\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: #0a74bb;\r\n      }\r\n\r\n      .cls-236 {\r\n        clip-path: url(#clippath-12);\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: #1071b8;\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: #0d5e9a;\r\n      }\r\n\r\n      .cls-237 {\r\n        clip-path: url(#clippath-134);\r\n      }\r\n\r\n      .cls-238 {\r\n        clip-path: url(#clippath-113);\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: #0e63a3;\r\n      }\r\n\r\n      .cls-239 {\r\n        clip-path: url(#clippath-178);\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: #007dc2;\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: #0c5c97;\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: #0093d4;\r\n      }\r\n\r\n      .cls-240 {\r\n        clip-path: url(#clippath-95);\r\n      }\r\n\r\n      .cls-241 {\r\n        clip-path: url(#clippath-80);\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: #0e73ba;\r\n      }\r\n\r\n      .cls-242 {\r\n        clip-path: url(#clippath-120);\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: #0e73bb;\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: #0d5f9d;\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: #00aae8;\r\n      }\r\n\r\n      .cls-243 {\r\n        clip-path: url(#clippath-147);\r\n      }\r\n\r\n      .cls-244 {\r\n        clip-path: url(#clippath-24);\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: #0083c7;\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: #0d73bb;\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: #0076bd;\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: #0575bc;\r\n      }\r\n\r\n      .cls-245 {\r\n        clip-path: url(#clippath-99);\r\n      }\r\n\r\n      .cls-246 {\r\n        clip-path: url(#clippath-166);\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: #106caf;\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: #0077be;\r\n      }\r\n\r\n      .cls-247 {\r\n        clip-path: url(#clippath-30);\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: #0d5f9b;\r\n      }\r\n\r\n      .cls-248 {\r\n        clip-path: url(#clippath-179);\r\n      }\r\n\r\n      .cls-249 {\r\n        clip-path: url(#clippath-79);\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: #939598;\r\n      }\r\n\r\n      .cls-250 {\r\n        clip-path: url(#clippath-22);\r\n      }\r\n\r\n      .cls-251 {\r\n        clip-path: url(#clippath-96);\r\n      }\r\n\r\n      .cls-252 {\r\n        clip-path: url(#clippath-150);\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: #0085c9;\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: #0075bc;\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: #0082c7;\r\n      }\r\n\r\n      .cls-253 {\r\n        clip-path: url(#clippath-183);\r\n      }\r\n\r\n      .cls-254 {\r\n        clip-path: url(#clippath-103);\r\n      }\r\n\r\n      .cls-255 {\r\n        clip-path: url(#clippath-126);\r\n      }\r\n\r\n      .cls-256 {\r\n        clip-path: url(#clippath-137);\r\n      }\r\n\r\n      .cls-257 {\r\n        clip-path: url(#clippath-9);\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: #009ede;\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: #00adea;\r\n      }\r\n\r\n      .cls-258 {\r\n        clip-path: url(#clippath-82);\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: #0d5e9b;\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: #0f65a5;\r\n      }\r\n\r\n      .cls-259 {\r\n        clip-path: url(#clippath-52);\r\n      }\r\n\r\n      .cls-260 {\r\n        clip-path: url(#clippath-144);\r\n      }\r\n\r\n      .cls-261 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: #0175bc;\r\n      }\r\n\r\n      .cls-262 {\r\n        clip-path: url(#clippath-187);\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: #0077bd;\r\n      }\r\n\r\n      .cls-263 {\r\n        clip-path: url(#clippath-50);\r\n      }\r\n\r\n      .cls-264 {\r\n        clip-path: url(#clippath-152);\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: #0080c5;\r\n      }\r\n\r\n      .cls-265 {\r\n        clip-path: url(#clippath-156);\r\n      }\r\n\r\n      .cls-266 {\r\n        clip-path: url(#clippath-48);\r\n      }\r\n\r\n      .cls-267 {\r\n        clip-path: url(#clippath-61);\r\n      }\r\n\r\n      .cls-268 {\r\n        clip-path: url(#clippath-180);\r\n      }\r\n\r\n      .cls-269 {\r\n        clip-path: url(#clippath-159);\r\n      }\r\n\r\n      .cls-270 {\r\n        clip-path: url(#clippath-39);\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: #0674bc;\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: #0e609d;\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: #0c5c98;\r\n      }\r\n\r\n      .cls-271 {\r\n        clip-path: url(#clippath-19);\r\n      }\r\n\r\n      .cls-272 {\r\n        clip-path: url(#clippath-31);\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: #106baf;\r\n      }\r\n\r\n      .cls-273 {\r\n        clip-path: url(#clippath-86);\r\n      }\r\n\r\n      .cls-274 {\r\n        clip-path: url(#clippath-54);\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: #0f69ac;\r\n      }\r\n\r\n      .cls-275 {\r\n        clip-path: url(#clippath-3);\r\n      }\r\n\r\n      .cls-276 {\r\n        clip-path: url(#clippath-131);\r\n      }\r\n\r\n      .cls-277 {\r\n        clip-path: url(#clippath-91);\r\n      }\r\n\r\n      .cls-278 {\r\n        clip-path: url(#clippath-129);\r\n      }\r\n\r\n      .cls-279 {\r\n        clip-path: url(#clippath-165);\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: #009bdb;\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: #00aeeb;\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: #106bae;\r\n      }\r\n\r\n      .cls-105 {\r\n        fill: #1072b9;\r\n      }\r\n\r\n      .cls-280 {\r\n        clip-path: url(#clippath-175);\r\n      }\r\n\r\n      .cls-281 {\r\n        clip-path: url(#clippath-155);\r\n      }\r\n\r\n      .cls-282 {\r\n        clip-path: url(#clippath-43);\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: #00a3e2;\r\n      }\r\n\r\n      .cls-283 {\r\n        clip-path: url(#clippath-171);\r\n      }\r\n\r\n      .cls-284 {\r\n        clip-path: url(#clippath-70);\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: #008ccf;\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: #0e619f;\r\n      }\r\n\r\n      .cls-285 {\r\n        clip-path: url(#clippath-8);\r\n      }\r\n\r\n      .cls-286 {\r\n        clip-path: url(#clippath-177);\r\n      }\r\n\r\n      .cls-287 {\r\n        opacity: .9;\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: #0c5b95;\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: #00a1e0;\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: #0f68a9;\r\n      }\r\n\r\n      .cls-288 {\r\n        clip-path: url(#clippath-133);\r\n      }\r\n\r\n      .cls-289 {\r\n        clip-path: url(#clippath-55);\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: #0086ca;\r\n      }\r\n\r\n      .cls-290 {\r\n        clip-path: url(#clippath-69);\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: #0d5c98;\r\n      }\r\n\r\n      .cls-114 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-291 {\r\n        clip-path: url(#clippath-140);\r\n      }\r\n\r\n      .cls-292 {\r\n        clip-path: url(#clippath-29);\r\n      }\r\n\r\n      .cls-293 {\r\n        clip-path: url(#clippath-18);\r\n      }\r\n\r\n      .cls-294 {\r\n        clip-path: url(#clippath-90);\r\n      }\r\n\r\n      .cls-295 {\r\n        clip-path: url(#clippath-14);\r\n      }\r\n\r\n      .cls-296 {\r\n        clip-path: url(#clippath-17);\r\n      }\r\n\r\n      .cls-297 {\r\n        clip-path: url(#clippath-97);\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: #106eb4;\r\n      }\r\n\r\n      .cls-116 {\r\n        fill: #0089cc;\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: #0090d2;\r\n      }\r\n\r\n      .cls-298 {\r\n        clip-path: url(#clippath-5);\r\n      }\r\n\r\n      .cls-299 {\r\n        clip-path: url(#clippath-174);\r\n      }\r\n\r\n      .cls-118 {\r\n        fill: #106eb3;\r\n      }\r\n\r\n      .cls-119 {\r\n        fill: #0874bb;\r\n      }\r\n\r\n      .cls-300 {\r\n        clip-path: url(#clippath-58);\r\n      }\r\n\r\n      .cls-301 {\r\n        clip-path: url(#clippath-84);\r\n      }\r\n\r\n      .cls-302 {\r\n        clip-path: url(#clippath-148);\r\n      }\r\n\r\n      .cls-303 {\r\n        clip-path: url(#clippath-42);\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: #0086c9;\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: #106fb4;\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: #1072ba;\r\n      }\r\n\r\n      .cls-304 {\r\n        clip-path: url(#clippath-65);\r\n      }\r\n\r\n      .cls-123 {\r\n        fill: #0c5b96;\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: #0e62a1;\r\n      }\r\n\r\n      .cls-305 {\r\n        clip-path: url(#clippath-10);\r\n      }\r\n\r\n      .cls-125 {\r\n        fill: #0f67a9;\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: #0078bf;\r\n      }\r\n\r\n      .cls-306 {\r\n        clip-path: url(#clippath-118);\r\n      }\r\n\r\n      .cls-307 {\r\n        clip-path: url(#clippath-23);\r\n      }\r\n\r\n      .cls-308 {\r\n        clip-path: url(#clippath-100);\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: #0b74bb;\r\n      }\r\n\r\n      .cls-309 {\r\n        clip-path: url(#clippath-92);\r\n      }\r\n\r\n      .cls-310 {\r\n        clip-path: url(#clippath-74);\r\n      }\r\n\r\n      .cls-311 {\r\n        clip-path: url(#clippath-56);\r\n      }\r\n\r\n      .cls-312 {\r\n        clip-path: url(#clippath-53);\r\n      }\r\n\r\n      .cls-313 {\r\n        clip-path: url(#clippath-49);\r\n      }\r\n\r\n      .cls-128 {\r\n        fill: #0f68aa;\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: #0f67a8;\r\n      }\r\n\r\n      .cls-130 {\r\n        fill: #009fdf;\r\n      }\r\n\r\n      .cls-314 {\r\n        clip-path: url(#clippath-110);\r\n      }\r\n\r\n      .cls-315 {\r\n        clip-path: url(#clippath-146);\r\n      }\r\n\r\n      .cls-316 {\r\n        clip-path: url(#clippath-67);\r\n      }\r\n\r\n      .cls-317 {\r\n        clip-path: url(#clippath-51);\r\n      }\r\n\r\n      .cls-318 {\r\n        clip-path: url(#clippath-145);\r\n      }\r\n\r\n      .cls-131 {\r\n        fill: #0e63a2;\r\n      }\r\n\r\n      .cls-132 {\r\n        fill: #0f66a6;\r\n      }\r\n\r\n      .cls-319 {\r\n        clip-path: url(#clippath-28);\r\n      }\r\n\r\n      .cls-320 {\r\n        clip-path: url(#clippath-71);\r\n      }\r\n\r\n      .cls-321 {\r\n        clip-path: url(#clippath-184);\r\n      }\r\n\r\n      .cls-133 {\r\n        fill: #0d5d99;\r\n      }\r\n\r\n      .cls-322 {\r\n        clip-path: url(#clippath-85);\r\n      }\r\n\r\n      .cls-134 {\r\n        fill: #0084c8;\r\n      }\r\n\r\n      .cls-323 {\r\n        clip-path: url(#clippath-106);\r\n      }\r\n\r\n      .cls-135 {\r\n        fill: #1073ba;\r\n      }\r\n\r\n      .cls-324 {\r\n        clip-path: url(#clippath-68);\r\n      }\r\n\r\n      .cls-325 {\r\n        clip-path: url(#clippath-143);\r\n      }\r\n\r\n      .cls-326 {\r\n        clip-path: url(#clippath-35);\r\n      }\r\n\r\n      .cls-327 {\r\n        clip-path: url(#clippath-66);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34,39.5c0-4.5,4-8.2,9-8.2,2.3,0,4.5.8,6.1,2.1.4-1.4.6-2.8.6-4.3,0-10.1-9.3-18.3-20.7-18.3-11.3,0-20.5,8.4-20.5,18.5,0,10.2,9.3,18.4,20.7,18.4,3,0,5.9-.6,8.5-1.7-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34,39.6c0-4.5,4-8.1,9-8.2,2.3,0,4.5.8,6.1,2.1.4-1.4.6-2.8.6-4.3,0-10.1-9.3-18.4-20.7-18.3-11.3,0-20.5,8.3-20.5,18.5,0,10.2,9.3,18.4,20.7,18.4,3,0,5.9-.6,8.5-1.7-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M39.5,24.6c-4.5-.1-8-4.2-7.9-9.2,0-2.3.9-4.5,2.2-6-1.4-.4-2.8-.6-4.3-.7-10.1-.2-18.6,8.8-18.9,20.2-.3,11.3,7.8,20.8,17.9,21,10.2.2,18.7-8.8,18.9-20.2,0-3-.5-5.9-1.5-8.5-1.5,2.2-3.9,3.5-6.6,3.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M39.5,24.6c-4.5-.1-8-4.2-7.9-9.2,0-2.3.9-4.5,2.2-6-1.4-.4-2.8-.6-4.3-.7-10.1-.2-18.6,8.8-18.9,20.2-.3,11.3,7.8,20.8,17.9,21,10.2.2,18.7-8.8,18.9-20.2,0-3-.5-5.9-1.5-8.5-1.5,2.2-3.9,3.5-6.6,3.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-164"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-171"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-174"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-175"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-182"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-183"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-186"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-188"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-189"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.9,39.6c0-4.5,4.1-8.1,9.1-8.1s4.5.8,6.1,2.1c.4-1.4.6-2.8.6-4.3,0-10.1-9.2-18.4-20.6-18.4S8.5,19.1,8.5,29.2s9.2,18.5,20.6,18.5,5.9-.6,8.5-1.6c-2.2-1.5-3.6-3.8-3.6-6.5Z"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "116.8 55.2 8.5 55.2 8.5 55.7 116.1 55.7 116.8 55.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-261"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 8.5,
    y: 10.8,
    width: 41.2,
    height: 36.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M48.6,29.3c0,10.8-8.7,19.5-19.5,19.5s-19.5-8.8-19.5-19.5S18.3,9.7,29.1,9.7s19.5,8.8,19.5,19.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M48.6,29.3c0,10.8-8.7,19.5-19.5,19.5s-19.5-8.7-19.5-19.5S18.3,9.8,29.1,9.8s19.5,8.7,19.5,19.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M48.5,29.3c0,10.8-8.7,19.5-19.5,19.5s-19.5-8.7-19.5-19.5S18.3,9.8,29.1,9.8c10.8,0,19.5,8.7,19.5,19.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M48.5,29.3c0,10.7-8.7,19.4-19.4,19.4s-19.4-8.7-19.4-19.4S18.3,9.8,29.1,9.8s19.4,8.7,19.4,19.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M48.5,29.3c0,10.7-8.7,19.4-19.4,19.4s-19.4-8.7-19.4-19.4S18.4,9.9,29.1,9.9s19.4,8.7,19.4,19.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M48.4,29.3c0,10.7-8.7,19.4-19.4,19.4s-19.4-8.7-19.4-19.4S18.4,9.9,29.1,9.9s19.4,8.7,19.4,19.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M48.4,29.3c0,10.7-8.7,19.3-19.3,19.3s-19.3-8.7-19.3-19.3S18.4,10,29.1,10c10.7,0,19.3,8.6,19.3,19.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-285"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M48.4,29.3c0,10.7-8.6,19.3-19.3,19.3s-19.3-8.6-19.3-19.3S18.4,10,29.1,10s19.3,8.6,19.3,19.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M48.3,29.3c0,10.6-8.6,19.2-19.3,19.2s-19.2-8.6-19.2-19.2S18.4,10,29.1,10c10.6,0,19.3,8.6,19.3,19.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-305"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M48.3,29.3c0,10.6-8.6,19.2-19.2,19.2s-19.2-8.6-19.2-19.2S18.4,10.1,29.1,10.1s19.2,8.6,19.2,19.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-92",
    cx: 29.1,
    cy: 29.3,
    rx: 19.2,
    ry: 19.2,
    transform: "translate(-.2 .2) rotate(-.3)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M48.2,29.3c0,10.6-8.6,19.2-19.2,19.2s-19.2-8.6-19.2-19.2S18.5,10.1,29.1,10.1s19.2,8.6,19.2,19.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M48.2,29.3c0,10.6-8.6,19.1-19.1,19.1s-19.1-8.6-19.1-19.1S18.5,10.2,29.1,10.2c10.6,0,19.1,8.6,19.1,19.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M48.1,29.3c0,10.5-8.5,19.1-19.1,19.1s-19.1-8.5-19.1-19.1S18.5,10.2,29.1,10.2s19.1,8.5,19.1,19.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M48.1,29.3c0,10.5-8.5,19-19,19s-19-8.5-19-19S18.6,10.2,29.1,10.2c10.5,0,19,8.5,19,19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M48.1,29.3c0,10.5-8.5,19-19,19s-19-8.5-19-19S18.6,10.3,29.1,10.3s19,8.5,19,19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48,29.3c0,10.5-8.5,19-19,19s-19-8.5-19-19S18.6,10.3,29.1,10.3c10.5,0,19,8.5,19,19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-293"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M48,29.3c0,10.5-8.5,18.9-18.9,18.9s-18.9-8.5-18.9-18.9S18.6,10.3,29.1,10.3s18.9,8.5,18.9,18.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M48,29.3c0,10.4-8.5,18.9-18.9,18.9s-18.9-8.5-18.9-18.9S18.6,10.4,29.1,10.4c10.4,0,18.9,8.5,18.9,18.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M47.9,29.3c0,10.4-8.4,18.9-18.9,18.9s-18.9-8.4-18.9-18.9S18.6,10.4,29.1,10.4c10.4,0,18.9,8.5,18.9,18.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M47.9,29.3c0,10.4-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8S18.7,10.4,29.1,10.4c10.4,0,18.8,8.4,18.8,18.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M47.9,29.3c0,10.4-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8S18.7,10.5,29.1,10.5s18.8,8.4,18.8,18.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M47.8,29.3c0,10.4-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8S18.7,10.5,29.1,10.5c10.4,0,18.8,8.4,18.8,18.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-244"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M47.8,29.3c0,10.3-8.4,18.7-18.7,18.7s-18.7-8.4-18.7-18.7S18.7,10.5,29.1,10.5s18.7,8.4,18.7,18.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M47.8,29.3c0,10.3-8.4,18.7-18.7,18.7s-18.7-8.4-18.7-18.7S18.7,10.6,29.1,10.6c10.3,0,18.7,8.4,18.7,18.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M47.7,29.3c0,10.3-8.3,18.7-18.7,18.7s-18.7-8.3-18.7-18.7S18.8,10.6,29.1,10.6c10.3,0,18.7,8.4,18.7,18.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.7,29.3c0,10.3-8.3,18.6-18.6,18.6s-18.6-8.3-18.6-18.6S18.8,10.7,29.1,10.7c10.3,0,18.6,8.3,18.6,18.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-319"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-60",
    cx: 29.1,
    cy: 29.3,
    rx: 18.6,
    ry: 18.6,
    transform: "translate(-.1 .1) rotate(-.2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M47.6,29.3c0,10.2-8.3,18.6-18.5,18.6s-18.6-8.3-18.6-18.6S18.8,10.7,29.1,10.7s18.5,8.3,18.5,18.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-247"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M47.6,29.3c0,10.2-8.3,18.5-18.5,18.5s-18.5-8.3-18.5-18.5S18.8,10.8,29.1,10.8c10.2,0,18.5,8.3,18.5,18.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-272"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M47.5,29.3c0,10.2-8.3,18.5-18.5,18.5s-18.5-8.3-18.5-18.5S18.9,10.8,29.1,10.8s18.5,8.3,18.5,18.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M47.5,29.3c0,10.2-8.3,18.4-18.4,18.4s-18.4-8.2-18.4-18.4S18.9,10.8,29.1,10.8c10.2,0,18.4,8.2,18.4,18.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M47.5,29.3c0,10.2-8.2,18.4-18.4,18.4s-18.4-8.2-18.4-18.4S18.9,10.9,29.1,10.9c10.2,0,18.4,8.2,18.4,18.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M47.4,29.3c0,10.2-8.2,18.4-18.4,18.4s-18.4-8.2-18.4-18.4S18.9,10.9,29.1,10.9s18.4,8.2,18.4,18.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-326"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M47.4,29.3c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3S18.9,10.9,29.1,10.9s18.3,8.2,18.3,18.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M47.4,29.3c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3S19,11,29.1,11c10.1,0,18.3,8.2,18.3,18.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M47.3,29.3c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3S19,11,29.1,11c10.1,0,18.3,8.2,18.3,18.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M47.3,29.3c0,10.1-8.2,18.2-18.2,18.2s-18.2-8.2-18.2-18.2S19,11,29.1,11c10.1,0,18.2,8.1,18.2,18.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M47.3,29.3c0,10.1-8.2,18.2-18.2,18.2s-18.2-8.2-18.2-18.2S19,11.1,29.1,11.1s18.2,8.1,18.2,18.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M47.2,29.3c0,10-8.1,18.2-18.2,18.2s-18.2-8.1-18.2-18.2S19,11.1,29.1,11.1s18.2,8.1,18.2,18.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M47.2,29.3c0,10-8.1,18.1-18.1,18.1s-18.1-8.1-18.1-18.1S19.1,11.1,29.1,11.1s18.1,8.1,18.1,18.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-303"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M47.2,29.3c0,10-8.1,18.1-18.1,18.1s-18.1-8.1-18.1-18.1S19.1,11.2,29.1,11.2s18.1,8.1,18.1,18.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-282"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.1,29.3c0,10-8.1,18.1-18.1,18.1s-18.1-8.1-18.1-18.1S19.1,11.2,29.1,11.2s18.1,8.1,18.1,18.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.1,29.3c0,9.9-8.1,18-18,18s-18-8.1-18-18S19.1,11.3,29.1,11.3c10,0,18,8.1,18,18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M47.1,29.3c0,9.9-8.1,18-18,18s-18-8.1-18-18S19.1,11.3,29.1,11.3s18,8,18,18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M47,29.3c0,9.9-8,17.9-18,17.9s-18-8-18-17.9S19.2,11.3,29.1,11.3c9.9,0,18,8,18,17.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M47,29.3c0,9.9-8,17.9-17.9,17.9s-17.9-8-17.9-17.9S19.2,11.4,29.1,11.4s17.9,8,17.9,17.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-266"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M46.9,29.3c0,9.9-8,17.9-17.9,17.9s-17.9-8-17.9-17.9S19.2,11.4,29.1,11.4c9.9,0,17.9,8,17.9,17.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M46.9,29.3c0,9.9-8,17.8-17.8,17.8s-17.8-8-17.8-17.8,8-17.8,17.8-17.8,17.8,8,17.8,17.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M46.9,29.3c0,9.8-8,17.8-17.8,17.8s-17.8-8-17.8-17.8,8-17.8,17.8-17.8c9.8,0,17.8,8,17.8,17.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-317"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M46.8,29.3c0,9.8-8,17.8-17.8,17.8s-17.8-8-17.8-17.8,8-17.8,17.8-17.8,17.8,8,17.8,17.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-259"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M46.8,29.3c0,9.8-7.9,17.7-17.8,17.7s-17.7-7.9-17.7-17.7,7.9-17.7,17.7-17.7c9.8,0,17.8,7.9,17.8,17.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-312"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M46.8,29.3c0,9.8-7.9,17.7-17.7,17.7s-17.7-7.9-17.7-17.7,7.9-17.7,17.7-17.7,17.7,7.9,17.7,17.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-274"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M46.7,29.3c0,9.8-7.9,17.7-17.7,17.7s-17.7-7.9-17.7-17.7,7.9-17.7,17.7-17.7c9.8,0,17.7,7.9,17.7,17.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-289"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M46.7,29.3c0,9.7-7.9,17.6-17.6,17.6s-17.6-7.9-17.6-17.6,7.9-17.6,17.6-17.6,17.6,7.9,17.6,17.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-311"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M46.7,29.3c0,9.7-7.9,17.6-17.6,17.6s-17.6-7.9-17.6-17.6,7.9-17.6,17.6-17.6,17.6,7.9,17.6,17.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M46.6,29.3c0,9.7-7.9,17.6-17.6,17.6s-17.6-7.9-17.6-17.6,7.9-17.6,17.6-17.6,17.6,7.9,17.6,17.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-300"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M46.6,29.3c0,9.7-7.8,17.5-17.5,17.5s-17.5-7.8-17.5-17.5,7.8-17.5,17.5-17.5c9.7,0,17.5,7.8,17.5,17.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M46.6,29.3c0,9.7-7.8,17.5-17.5,17.5s-17.5-7.8-17.5-17.5,7.8-17.5,17.5-17.5,17.5,7.8,17.5,17.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-230"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M46.5,29.3c0,9.6-7.8,17.5-17.5,17.5s-17.5-7.8-17.5-17.5,7.8-17.5,17.5-17.5c9.7,0,17.5,7.8,17.5,17.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.5,29.3c0,9.6-7.8,17.4-17.4,17.4s-17.4-7.8-17.4-17.4,7.8-17.4,17.4-17.4,17.4,7.8,17.4,17.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M46.5,29.3c0,9.6-7.8,17.4-17.4,17.4s-17.4-7.8-17.4-17.4,7.8-17.4,17.4-17.4,17.4,7.8,17.4,17.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 29.1,
    cy: 29.3,
    r: 17.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M46.4,29.3c0,9.6-7.8,17.3-17.3,17.3s-17.3-7.8-17.3-17.3,7.8-17.3,17.3-17.3c9.6,0,17.3,7.8,17.3,17.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-304"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M46.4,29.3c0,9.6-7.7,17.3-17.3,17.3s-17.3-7.7-17.3-17.3,7.7-17.3,17.3-17.3,17.3,7.7,17.3,17.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-327"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M46.2,29.3c0,9.5-7.7,17.2-17.2,17.2s-17.2-7.7-17.2-17.2,7.7-17.2,17.2-17.2,17.2,7.7,17.2,17.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-316"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M46.1,29.3c0,9.4-7.6,17-17,17s-17-7.6-17-17,7.6-17,17-17,17,7.6,17,17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-324"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45.9,29.3c0,9.3-7.6,16.9-16.9,16.9s-16.9-7.6-16.9-16.9,7.6-16.9,16.9-16.9c9.3,0,16.9,7.6,16.9,16.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45.8,29.3c0,9.2-7.5,16.7-16.7,16.7s-16.7-7.5-16.7-16.7,7.5-16.7,16.7-16.7,16.7,7.5,16.7,16.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45.7,29.3c0,9.2-7.4,16.6-16.6,16.6s-16.6-7.4-16.6-16.6,7.4-16.6,16.6-16.6c9.2,0,16.6,7.4,16.6,16.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-320"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45.5,29.3c0,9.1-7.4,16.4-16.5,16.4s-16.5-7.4-16.5-16.4,7.4-16.4,16.5-16.4c9.1,0,16.5,7.4,16.5,16.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45.4,29.3c0,9-7.3,16.3-16.3,16.3s-16.3-7.3-16.3-16.3,7.3-16.3,16.3-16.3,16.3,7.3,16.3,16.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45.2,29.3c0,8.9-7.2,16.2-16.2,16.2s-16.2-7.2-16.2-16.2,7.2-16.2,16.2-16.2,16.2,7.2,16.2,16.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-310"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45.1,29.3c0,8.9-7.2,16-16,16s-16-7.2-16-16,7.2-16,16-16c8.9,0,16,7.2,16,16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M45,29.3c0,8.8-7.1,15.9-15.9,15.9s-15.9-7.1-15.9-15.9,7.1-15.9,15.9-15.9c8.8,0,15.9,7.1,15.9,15.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M44.8,29.3c0,8.7-7.1,15.8-15.8,15.8s-15.8-7.1-15.8-15.8,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M44.7,29.3c0,8.6-7,15.6-15.6,15.6s-15.6-7-15.6-15.6,7-15.6,15.6-15.6,15.6,7,15.6,15.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M44.6,29.3c0,8.6-6.9,15.5-15.5,15.5s-15.5-6.9-15.5-15.5,6.9-15.5,15.5-15.5,15.5,6.9,15.5,15.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M44.4,29.3c0,8.5-6.9,15.3-15.3,15.3s-15.3-6.9-15.3-15.3,6.9-15.3,15.3-15.3,15.3,6.9,15.3,15.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M44.3,29.3c0,8.4-6.8,15.2-15.2,15.2s-15.2-6.8-15.2-15.2,6.8-15.2,15.2-15.2,15.2,6.8,15.2,15.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M44.1,29.3c0,8.3-6.8,15.1-15.1,15.1s-15.1-6.7-15.1-15.1,6.8-15.1,15.1-15.1c8.3,0,15.1,6.7,15.1,15.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M44,29.3c0,8.2-6.7,14.9-14.9,14.9s-14.9-6.7-14.9-14.9,6.7-14.9,14.9-14.9,14.9,6.7,14.9,14.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M43.9,29.3c0,8.2-6.6,14.8-14.8,14.8s-14.8-6.6-14.8-14.8,6.6-14.8,14.8-14.8,14.8,6.6,14.8,14.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-301"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M43.7,29.3c0,8.1-6.6,14.7-14.7,14.7s-14.7-6.6-14.7-14.7,6.6-14.7,14.7-14.7c8.1,0,14.7,6.6,14.7,14.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-322"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M43.6,29.3c0,8-6.5,14.5-14.5,14.5s-14.5-6.5-14.5-14.5,6.5-14.5,14.5-14.5c8,0,14.5,6.5,14.5,14.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M43.4,29.3c0,7.9-6.4,14.4-14.4,14.4s-14.4-6.4-14.4-14.4,6.4-14.4,14.4-14.4c7.9,0,14.4,6.4,14.4,14.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M43.3,29.3c0,7.9-6.4,14.2-14.2,14.2s-14.2-6.4-14.2-14.2,6.4-14.2,14.2-14.2c7.9,0,14.2,6.4,14.2,14.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M43.2,29.3c0,7.8-6.3,14.1-14.1,14.1s-14.1-6.3-14.1-14.1,6.3-14.1,14.1-14.1,14.1,6.3,14.1,14.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M43,29.3c0,7.7-6.2,14-14,14s-14-6.2-14-14,6.3-14,14-14,14,6.2,14,14Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M42.9,29.3c0,7.6-6.2,13.8-13.8,13.8s-13.8-6.2-13.8-13.8,6.2-13.8,13.8-13.8,13.8,6.2,13.8,13.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-277"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M42.8,29.3c0,7.6-6.1,13.7-13.7,13.7s-13.7-6.1-13.7-13.7,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-309"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M42.6,29.3c0,7.5-6.1,13.6-13.6,13.6s-13.6-6.1-13.6-13.6,6.1-13.6,13.6-13.6c7.5,0,13.6,6.1,13.6,13.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M42.5,29.3c0,7.4-6,13.4-13.4,13.4s-13.4-6-13.4-13.4,6-13.4,13.4-13.4c7.4,0,13.4,6,13.4,13.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M42.3,29.3c0,7.3-5.9,13.3-13.3,13.3s-13.3-5.9-13.3-13.3,5.9-13.3,13.3-13.3,13.3,5.9,13.3,13.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-240"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M42.2,29.3c0,7.2-5.9,13.1-13.1,13.1s-13.1-5.9-13.1-13.1,5.9-13.1,13.1-13.1,13.1,5.9,13.1,13.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M42.1,29.3c0,7.2-5.8,13-13,13s-13-5.8-13-13,5.8-13,13-13,13,5.8,13,13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-297"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M41.9,29.3c0,7.1-5.8,12.9-12.9,12.9s-12.9-5.8-12.9-12.9,5.8-12.9,12.9-12.9,12.9,5.8,12.9,12.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M41.8,29.3c0,7-5.7,12.7-12.7,12.7s-12.7-5.7-12.7-12.7,5.7-12.7,12.7-12.7,12.7,5.7,12.7,12.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M41.7,29.3c0,6.9-5.6,12.6-12.6,12.6s-12.6-5.6-12.6-12.6,5.6-12.6,12.6-12.6c6.9,0,12.6,5.6,12.6,12.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-308"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M41.5,29.3c0,6.9-5.6,12.4-12.4,12.4s-12.4-5.6-12.4-12.4,5.6-12.4,12.4-12.4,12.4,5.6,12.4,12.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-229"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M41.4,29.3c0,6.8-5.5,12.3-12.3,12.3s-12.3-5.5-12.3-12.3,5.5-12.3,12.3-12.3,12.3,5.5,12.3,12.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-216"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M41.2,29.3c0,6.7-5.4,12.2-12.2,12.2s-12.2-5.4-12.2-12.2,5.4-12.2,12.2-12.2,12.2,5.4,12.2,12.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-254"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M41.1,29.3c0,6.7-5.4,12-12,12s-12-5.4-12-12,5.4-12,12-12c6.6,0,12,5.4,12,12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M41,29.3c0,6.6-5.3,11.9-11.9,11.9s-11.9-5.3-11.9-11.9,5.3-11.9,11.9-11.9,11.9,5.3,11.9,11.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.8,29.3c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8c6.5,0,11.8,5.2,11.8,11.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-323"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M40.7,29.3c0,6.4-5.2,11.6-11.6,11.6s-11.6-5.2-11.6-11.6,5.2-11.6,11.6-11.6,11.6,5.2,11.6,11.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-94",
    cx: 29.1,
    cy: 29.3,
    r: 11.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M40.4,29.3c0,6.3-5.1,11.3-11.3,11.3s-11.3-5.1-11.3-11.3,5.1-11.3,11.3-11.3,11.3,5.1,11.3,11.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M40.3,29.3c0,6.2-5,11.2-11.2,11.2s-11.2-5-11.2-11.2,5-11.2,11.2-11.2c6.2,0,11.2,5,11.2,11.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M40.1,29.3c0,6.1-4.9,11.1-11.1,11.1s-11.1-4.9-11.1-11.1,4.9-11.1,11.1-11.1c6.1,0,11.1,4.9,11.1,11.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M40,29.3c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9,4.9-10.9,10.9-10.9,10.9,4.9,10.9,10.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M39.9,29.3c0,6-4.8,10.8-10.8,10.8s-10.8-4.8-10.8-10.8,4.8-10.8,10.8-10.8,10.8,4.8,10.8,10.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M39.7,29.3c0,5.9-4.8,10.7-10.7,10.7s-10.7-4.8-10.7-10.7,4.8-10.7,10.7-10.7c5.9,0,10.7,4.8,10.7,10.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M39.6,29.3c0,5.8-4.7,10.5-10.5,10.5s-10.5-4.7-10.5-10.5,4.7-10.5,10.5-10.5,10.5,4.7,10.5,10.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M39.4,29.3c0,5.7-4.6,10.4-10.4,10.4s-10.4-4.6-10.4-10.4,4.7-10.4,10.4-10.4c5.7,0,10.4,4.6,10.4,10.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M39.3,29.3c0,5.7-4.6,10.2-10.2,10.2s-10.2-4.6-10.2-10.2,4.6-10.2,10.2-10.2c5.7,0,10.2,4.6,10.2,10.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.2,29.3c0,5.6-4.5,10.1-10.1,10.1s-10.1-4.5-10.1-10.1,4.5-10.1,10.1-10.1c5.6,0,10.1,4.5,10.1,10.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-306"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39,29.3c0,5.5-4.5,10-10,10s-9.9-4.5-9.9-10,4.4-9.9,9.9-9.9c5.5,0,10,4.4,10,9.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M38.9,29.3c0,5.4-4.4,9.8-9.8,9.8s-9.8-4.4-9.8-9.8,4.4-9.8,9.8-9.8,9.8,4.4,9.8,9.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M38.7,29.3c0,5.3-4.3,9.7-9.7,9.7s-9.7-4.3-9.7-9.7,4.3-9.7,9.7-9.7,9.7,4.3,9.7,9.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M38.6,29.3c0,5.3-4.3,9.5-9.5,9.5s-9.5-4.3-9.5-9.5,4.3-9.5,9.5-9.5c5.3,0,9.5,4.3,9.5,9.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M38.5,29.3c0,5.2-4.2,9.4-9.4,9.4s-9.4-4.2-9.4-9.4,4.2-9.4,9.4-9.4c5.2,0,9.4,4.2,9.4,9.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M38.3,29.3c0,5.1-4.2,9.3-9.3,9.3s-9.3-4.2-9.3-9.3,4.2-9.3,9.3-9.3c5.1,0,9.3,4.2,9.3,9.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M38.2,29.3c0,5-4.1,9.1-9.1,9.1s-9.1-4.1-9.1-9.1,4.1-9.1,9.1-9.1,9.1,4.1,9.1,9.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M38.1,29.3c0,5-4,9-9,9s-9-4-9-9,4-9,9-9,9,4,9,9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-255"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M37.9,29.3c0,4.9-4,8.8-8.8,8.8s-8.8-4-8.8-8.8,4-8.8,8.8-8.8,8.8,4,8.8,8.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M37.8,29.3c0,4.8-3.9,8.7-8.7,8.7s-8.7-3.9-8.7-8.7,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M37.6,29.3c0,4.7-3.8,8.6-8.6,8.6s-8.6-3.8-8.6-8.6,3.8-8.6,8.6-8.6,8.6,3.8,8.6,8.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M37.5,29.3c0,4.7-3.8,8.4-8.4,8.4s-8.4-3.8-8.4-8.4,3.8-8.4,8.4-8.4,8.4,3.8,8.4,8.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M37.4,29.3c0,4.6-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3,3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M37.2,29.3c0,4.5-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2,3.7-8.2,8.2-8.2c4.5,0,8.2,3.7,8.2,8.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M37.1,29.3c0,4.4-3.6,8-8,8s-8-3.6-8-8,3.6-8,8-8c4.4,0,8,3.6,8,8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M36.9,29.3c0,4.3-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9,3.5-7.9,7.9-7.9c4.3,0,7.9,3.5,7.9,7.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M36.8,29.3c0,4.3-3.5,7.7-7.8,7.7s-7.7-3.5-7.7-7.7,3.5-7.7,7.7-7.7c4.3,0,7.8,3.5,7.8,7.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M36.7,29.3c0,4.2-3.4,7.6-7.6,7.6s-7.6-3.4-7.6-7.6,3.4-7.6,7.6-7.6,7.6,3.4,7.6,7.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M36.5,29.3c0,4.1-3.3,7.5-7.5,7.5s-7.5-3.3-7.5-7.5,3.3-7.5,7.5-7.5,7.5,3.3,7.5,7.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-256"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M36.4,29.3c0,4.1-3.3,7.3-7.3,7.3s-7.3-3.3-7.3-7.3,3.3-7.3,7.3-7.3,7.3,3.3,7.3,7.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M36.3,29.3c0,4-3.2,7.2-7.2,7.2s-7.2-3.2-7.2-7.2,3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M36.1,29.3c0,3.9-3.2,7.1-7.1,7.1s-7.1-3.2-7.1-7.1,3.2-7.1,7.1-7.1,7.1,3.2,7.1,7.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-291"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M36,29.3c0,3.8-3.1,6.9-6.9,6.9s-6.9-3.1-6.9-6.9,3.1-6.9,6.9-6.9c3.8,0,6.9,3.1,6.9,6.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M35.8,29.3c0,3.7-3,6.8-6.8,6.8s-6.8-3-6.8-6.8,3-6.8,6.8-6.8,6.8,3,6.8,6.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M35.7,29.3c0,3.7-3,6.6-6.6,6.6s-6.6-3-6.6-6.6,3-6.6,6.6-6.6,6.6,3,6.6,6.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-325"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M35.6,29.3c0,3.6-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5,2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M35.4,29.3c0,3.5-2.8,6.4-6.4,6.4s-6.4-2.8-6.4-6.4,2.8-6.4,6.4-6.4c3.5,0,6.4,2.8,6.4,6.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-318"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M35.3,29.3c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2,2.8-6.2,6.2-6.2c3.4,0,6.2,2.8,6.2,6.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-315"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M35.2,29.3c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1,2.7-6.1,6.1-6.1c3.4,0,6.1,2.7,6.1,6.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-243"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M35,29.3c0,3.3-2.7,5.9-5.9,5.9s-5.9-2.7-5.9-5.9,2.7-5.9,5.9-5.9,5.9,2.7,5.9,5.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-302"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M34.9,29.3c0,3.2-2.6,5.8-5.8,5.8s-5.8-2.6-5.8-5.8,2.6-5.8,5.8-5.8,5.8,2.6,5.8,5.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M34.7,29.3c0,3.1-2.5,5.7-5.7,5.7s-5.7-2.5-5.7-5.7,2.5-5.7,5.7-5.7,5.7,2.5,5.7,5.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M34.6,29.3c0,3.1-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5,2.5-5.5,5.5-5.5c3.1,0,5.5,2.5,5.5,5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.5,29.3c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4,2.4-5.4,5.4-5.4c3,0,5.4,2.4,5.4,5.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M34.3,29.3c0,2.9-2.3,5.2-5.2,5.2s-5.3-2.3-5.3-5.2,2.3-5.2,5.3-5.2,5.2,2.3,5.2,5.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M34.2,29.3c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1,2.3-5.1,5.1-5.1,5.1,2.3,5.1,5.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M34,29.3c0,2.8-2.2,5-5,5s-5-2.2-5-5,2.2-5,5-5c2.8,0,5,2.2,5,5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-281"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.9,29.3c0,2.7-2.2,4.8-4.8,4.8s-4.8-2.2-4.8-4.8,2.2-4.8,4.8-4.8,4.8,2.2,4.8,4.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M33.8,29.3c0,2.6-2.1,4.7-4.7,4.7s-4.7-2.1-4.7-4.7,2.1-4.7,4.7-4.7,4.7,2.1,4.7,4.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M33.6,29.3c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6,2-4.6,4.6-4.6,4.6,2,4.6,4.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M33.5,29.3c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4,2-4.4,4.4-4.4,4.4,2,4.4,4.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-269"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M33.4,29.3c0,2.4-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3,1.9-4.3,4.3-4.3,4.3,1.9,4.3,4.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M33.2,29.3c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2,1.9-4.2,4.2-4.2,4.2,1.8,4.2,4.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M33.1,29.3c0,2.2-1.8,4-4,4s-4-1.8-4-4,1.8-4,4-4c2.2,0,4,1.8,4,4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.9,29.3c0,2.1-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9,1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M32.8,29.3c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7,1.7-3.7,3.7-3.7c2.1,0,3.7,1.7,3.7,3.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M32.7,29.3c0,2-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6,1.6-3.6,3.6-3.6,3.6,1.6,3.6,3.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-279"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.5,29.3c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5,1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-246"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M32.4,29.3c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3,1.5-3.3,3.3-3.3,3.3,1.5,3.3,3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M32.2,29.3c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M32.1,29.3c0,1.7-1.4,3-3,3s-3-1.4-3-3,1.4-3,3-3c1.7,0,3,1.3,3,3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M32,29.3c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M31.8,29.3c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-283"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M31.7,29.3c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6,1.2-2.6,2.6-2.6,2.6,1.2,2.6,2.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M31.6,29.3c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5,1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M31.4,29.3c0,1.3-1.1,2.3-2.3,2.3s-2.3-1.1-2.3-2.3,1.1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-299"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M31.3,29.3c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-280"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M31.1,29.3c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M31,29.3c0,1.1-.9,1.9-1.9,1.9s-1.9-.9-1.9-1.9.9-1.9,1.9-1.9,1.9.9,1.9,1.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-286"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M30.9,29.3c0,1-.8,1.8-1.8,1.8s-1.8-.8-1.8-1.8.8-1.8,1.8-1.8,1.8.8,1.8,1.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M30.7,29.3c0,.9-.7,1.7-1.7,1.7s-1.7-.7-1.7-1.7.7-1.7,1.7-1.7c.9,0,1.7.7,1.7,1.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M30.6,29.3c0,.8-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5.7-1.5,1.5-1.5c.8,0,1.5.7,1.5,1.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-268"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M30.5,29.3c0,.8-.6,1.4-1.4,1.4s-1.4-.6-1.4-1.4.6-1.4,1.4-1.4c.8,0,1.4.6,1.4,1.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M30.3,29.3c0,.7-.6,1.2-1.2,1.2s-1.2-.6-1.2-1.2.6-1.2,1.2-1.2c.7,0,1.2.5,1.2,1.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M30.2,29.3c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M30,29.3c0,.5-.4,1-1,1s-1-.4-1-1,.4-1,1-1,1,.4,1,1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-321"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M29.9,29.3c0,.5-.4.8-.8.8s-.8-.4-.8-.8.4-.8.8-.8.8.4.8.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M29.8,29.3c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7c.4,0,.7.3.7.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M29.6,29.3c0,.3-.2.6-.6.6s-.6-.2-.6-.6.2-.6.6-.6c.3,0,.6.2.6.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-262"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M29.5,29.3c0,.2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4c.2,0,.4.2.4.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M29.3,29.3c0,.2-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3.3.1.3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M29.2,29.3c0,0,0,.1-.1.1s-.1,0-.1-.1,0-.1.1-.1.1,0,.1.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-287"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-226",
    width: 518,
    height: 459,
    transform: "translate(7.8 10.4) scale(0)",
    xlinkHref: "logo_orbis-1.png"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M35.4,46.3c-2,.6-4.1.9-6.3.9h0v-10.9c.2,0,.5,0,.7,0,0-.2.1-.3.2-.5-.3,0-.6,0-.9,0v-7.5c2.8,0,5.6-.1,8.3-.6.3.9.5,1.8.7,2.8.1,0,.2,0,.4,0-.2-.9-.4-1.8-.7-2.8,2.3-.5,4.4-1.2,6.2-2.3.9,1.4,1.7,2.9,2.3,4.5.1,0,.3,0,.4,0-.6-1.7-1.4-3.3-2.4-4.8,1.2-.7,2.2-1.6,3-2.6.5.7.9,1.5,1.4,2.3.3,1.2.5,2.3.6,3.6-.4.7-.9,1.2-1.5,1.8.2,0,.3.1.4.2.4-.4.7-.8,1.1-1.3v.2c0,.6,0,1.2,0,1.7.1.1.2.2.3.3,0-.7.1-1.4.1-2.1,0-10.1-9.2-18.4-20.6-18.4s-17.9,6.1-20,14.2t0,0h0c-.3,1.3-.5,2.7-.5,4.2,0,10.2,9.2,18.5,20.6,18.5s4.7-.4,6.8-1.1c-.2,0-.4-.2-.5-.3ZM29,27.8v-8.3c1.3,0,2.6-.2,4-.4,1.9,2.6,3.3,5.3,4.2,8.1-2.6.5-5.4.7-8.2.6ZM36.2,18c-.9.3-2,.5-3.1.7-.7-1-1.5-2-2.4-3,.3,0,.6-.1.9-.2,1.7.8,3.2,1.6,4.6,2.5ZM32.2,15.2c.5-.2.9-.5,1.1-.9,2.1.4,4.4,1,6.5,2-.6.6-1.6,1.1-3,1.5-1.4-.9-2.9-1.8-4.6-2.6ZM32.6,18.7c-1.2.2-2.4.3-3.6.3v-3.2c.4,0,.8,0,1.2,0,.9,1,1.7,2,2.5,3ZM37.5,27.1c-.9-2.7-2.3-5.4-4.1-8.1,1.2-.2,2.3-.4,3.4-.7,2.9,1.9,5.1,4.1,6.9,6.6-1.8,1-3.9,1.7-6.1,2.2ZM44,24.7c-1.7-2.5-3.9-4.7-6.7-6.6,1.3-.4,2.3-1,2.9-1.6,2.5,1.2,4.9,3,6.8,5.6-.8,1-1.9,1.9-3,2.6ZM47.6,22.1c0,.2.2.4.2.6,0-.2-.2-.3-.3-.5,0,0,0,0,0,0ZM47.4,21.7s0,0,0,.1c-1.9-2.7-4.3-4.4-6.8-5.7,0-.2.1-.3.2-.5,0-.4,0-.8-.2-1.2,3,1.8,5.5,4.3,7,7.3ZM39.2,13.8c.6.5,1.2,1.1,1.1,1.7,0,.2,0,.3-.2.4-2.3-1.1-4.6-1.7-6.8-2.1,0-.2-.1-.4-.2-.5l4.3-.4c.6.2,1.2.5,1.8.8ZM36.3,12.5l-3.8.3c-.4-.3-1.1-.5-1.7-.6l.6-.8c1.7.2,3.4.5,5,1.1ZM29.2,11.3c.6,0,1.2,0,1.7,0l-.5.8c-.4,0-.9,0-1.3-.1v-.7ZM28.8,11.3v.7c-.5,0-.9,0-1.2,0l-.2-.7c.5,0,1,0,1.4,0ZM27.3,12.7h0c.4,0,.9-.1,1.4-.1,1.9,0,3.4.5,3.9,1h-1.8c-.3-.6-1.5-.7-2.2-.7s-1.9.2-2.2.7h-1.6c.4-.4,1.3-.7,2.4-.9,0,0,0,0,0,0ZM30.7,13.9s-.1.2-.5.3c-.4.2-.9.2-1.4.2-1.1,0-1.8-.3-1.9-.6,0,0,0,0,0,0,.1-.2.8-.5,1.9-.5s1.8.3,1.9.5c0,0,0,0,0,.1ZM26.9,11.4l.2.7c-.7,0-1.3.3-1.7.5l-1.7-.7c1-.2,2.1-.4,3.2-.5ZM23,12.2l2,.8c-.1,0-.2.2-.3.3h-4.3c.9-.5,1.8-.8,2.7-1.1ZM14.9,25.8c1.8.7,4,1.3,6.4,1.7-.9,2.5-1.4,4.9-1.6,7.1-2.8-.7-5.2-1.5-7-2.6,0-.5.1-1,.2-1.4.4-1.7,1-3.3,1.9-4.9ZM14.8,25.2c-1.7-.7-3-1.4-3.8-2.2,2.1-2.6,4.5-4.6,7.3-6.1.5.6,1.2,1.1,2.2,1.5-2.5,2.2-4.4,4.5-5.8,6.8ZM15.2,25.4c1.4-2.3,3.3-4.5,5.9-6.7,1,.4,2.3.7,3.9.8-1.5,2.7-2.6,5.2-3.5,7.6-2.4-.4-4.6-1-6.3-1.7ZM21.5,18.3c1.2-1,2.6-2.1,4-3.1,0,0,.1,0,.2,0,.4.2.9.3,1.4.4-.7,1.1-1.3,2.2-1.9,3.3-1.5-.1-2.7-.3-3.8-.7ZM21,18.1c-1-.4-1.7-.8-2.2-1.3,1.8-.9,3.7-1.6,5.9-2.1.1.1.2.2.4.3-1.5,1-2.9,2.1-4.1,3.1ZM18.8,13.8c.2,0,.3-.2.5-.3l5.1.2c0,0,0,.2,0,.2s0,.2,0,.3c-2.2.6-4.1,1.3-5.9,2.2-.2-.2-.3-.5-.4-.8-.1-.6.1-1.3.7-1.8ZM17.9,14.3c-.2.5-.3,1-.2,1.5,0,.3.2.5.3.8-2.8,1.5-5.2,3.5-7.3,6.1-.1-.2-.2-.3-.3-.4,1.5-3.3,4.2-6,7.5-8ZM10.2,22.7c0,.1.2.2.2.3-.3.3-.5.7-.8,1,.2-.5.3-.9.5-1.3ZM9.3,25.3c.5-.7.9-1.3,1.4-1.9.8.8,2.1,1.6,3.8,2.3-.9,1.6-1.5,3.2-1.9,4.9,0,.5-.2.9-.2,1.4-1.8-1.1-3-2.3-3.5-3.5h0c0-1.1.2-2.1.5-3.1ZM8.8,29.2h0c.6,1.1,1.8,2.2,3.5,3.2-.3,2.7.1,5.5,1.2,8.3-2.9-3.1-4.7-7.1-4.7-11.5ZM14.1,41.3h0c-1.2-3-1.7-5.9-1.5-8.7,1.8,1,4.2,1.9,7,2.5-.3,3.9.3,7.4,1.9,10.8-2.9-1-5.4-2.6-7.5-4.6ZM28.6,47.2c-2.3,0-4.5-.4-6.5-1.1-1.7-3.4-2.4-7-2.1-10.9.7.2,1.5.3,2.3.4,2,.3,4.2.6,6.3.6v10.9ZM28.6,35.8c-2.1,0-4.2-.3-6.2-.6-.8-.1-1.6-.3-2.3-.5.2-2.3.8-4.6,1.6-7.1,1.1.2,2.2.3,3.3.5,1.2.1,2.4.2,3.6.2,0,0,0,7.5,0,7.5ZM28.6,27.8c-1.2,0-2.4-.1-3.6-.2-1.1-.1-2.2-.3-3.2-.4.9-2.4,2.1-4.9,3.5-7.6.6,0,1.2,0,1.9,0s.8,0,1.3,0c0,0,0,8.3,0,8.3ZM28.6,19c-.4,0-.8,0-1.3,0-.6,0-1.1,0-1.7,0,.6-1.1,1.2-2.2,1.9-3.3.3,0,.7,0,1,0v3.2h0ZM25.8,14.8c-.4-.2-.7-.3-.9-.5,0,0,0,0,0,0h1.6c.3.6,1.5.7,2.2.7s1.1,0,1.6-.3c.3-.1.5-.3.7-.5h1.9c-.4.5-1.8,1.1-4,1.1s-2.2-.2-3-.5Z"
  })), /*#__PURE__*/React.createElement("image", {
    className: "cls-226",
    width: 1188,
    height: 259,
    transform: "translate(29.6 28.2) scale(0)",
    xlinkHref: "logo_orbis-2.png"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M42.4,28.9c-7.8,0-13.3,4.1-13.3,9.9s5.2,9.7,12.8,9.7,13.4-3.9,13.4-10c0-4.8-4-9.6-12.9-9.6ZM42.3,44.2c-3.5,0-5.8-2.2-5.8-5.5s2.3-5.6,5.8-5.6,5.8,2.8,5.8,5.5c0,3.4-2.3,5.6-5.8,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M76.1,44.1c-.2-.6-.4-1.2-.7-1.7-.6-1.5-1.4-2.5-2.6-3.2,2-.8,3.7-2.4,3.7-4.5s-.9-3.3-2.7-4.2c-1.9-1-4.6-1.5-8.7-1.5s-5.8.1-7.9.4h-.5v18.8h6.9v-7.1h1.2c2.3,0,3.1.6,3.7,2.5.8,2.3,1.4,3.8,1.9,4.3l.2.2h7.4l-.6-.8c-.4-.4-.9-1.9-1.4-3.2ZM69.7,35.1c0,1.3-1.6,2.1-4.2,2.1h-1.8v-3.9c.6,0,1.3,0,2.1,0,1.8,0,3.8.4,3.8,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M94.9,37.9c2-.9,3.1-2.2,3.1-3.8s-1.3-3.2-3.5-4c-1.9-.8-4-1.1-7.9-1.1s-6.1.2-7.7.4h-.5v18.7h.5c1,.2,3.2.3,6.5.3,5.1,0,8.4-.5,10.5-1.7,2-1.1,3-2.6,3-4.3,0-2-1.5-3.6-4-4.5ZM86.8,36.3h-1.4v-3.2c.4,0,1.1,0,2,0s3.7.2,3.7,1.6-1.7,1.7-4.2,1.7ZM85.4,40.3h1.5c1.1,0,4.8.2,4.8,2s-3.4,2.1-4.5,2.1-1.3,0-1.8,0v-4h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 100.5,
    y: 29.2,
    width: 7,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M121.1,36.5c-3.1-.8-4.4-1.3-4.4-2s1.1-1.2,3.3-1.2,3.6.3,5.3.8l.5.2,1.7-4.3-.6-.2c-2-.6-4.3-.9-6.8-.9-6.2,0-10.4,2.4-10.4,5.9s2.5,4.6,7.6,5.8c2.9.7,4,1.3,4,2s-1.4,1.4-3.6,1.4-5.6-.8-6.4-1.1l-.5-.2-1.6,4.3.5.2c1.5.6,4.5,1.2,7.6,1.2,8.2,0,11.1-3.2,11.1-6.1,0-3.7-4.1-5.1-7.2-5.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M54.8,38.5c0,5.9-5.2,9.5-12.8,9.5s-12.3-4-12.3-9.2,5-9.4,12.7-9.4,12.4,4.1,12.4,9.1ZM35.9,38.8c0,3.5,2.4,6,6.4,6s6.3-2.6,6.3-6.1-2.2-6-6.3-6-6.3,2.6-6.3,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M57.3,30c1.9-.2,4.7-.4,7.9-.4s6.6.4,8.5,1.4c1.6.9,2.4,2.1,2.4,3.8s-2.4,3.9-4.6,4.4h0c1.8.6,2.8,1.8,3.5,3.4.8,2,1.6,4.4,2.1,5.1h-6.1c-.4-.5-1.1-2-1.8-4.2-.7-2.2-1.8-2.9-4.2-2.9h-1.8v7.1h-5.9v-17.8h0ZM63.2,37.7h2.3c2.9,0,4.7-1,4.7-2.6s-1.6-2.5-4.3-2.5c-1.4,0-2.2,0-2.7.1,0,0,0,5,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M79,30c1.6-.2,4.7-.4,7.6-.4s5.8.2,7.7,1c1.8.7,3.1,1.9,3.1,3.5s-1.4,3.1-4.3,3.8h0c3,.6,5.2,2.2,5.2,4.5s-1.1,2.9-2.7,3.8c-1.9,1-5.1,1.6-10.3,1.6s-5.1-.1-6.4-.3v-17.7h0ZM84.9,36.8h1.9c3.1,0,4.8-.9,4.8-2.2s-1.5-2.1-4.2-2.1-2,0-2.5,0v4.2ZM84.9,44.8c.6,0,1.3,0,2.3,0,2.7,0,5.1-.7,5.1-2.6s-2.4-2.5-5.3-2.5h-2v5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M107,29.7v18h-5.9v-18h5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M111,43.5c1.6.6,4,1.1,6.6,1.1s4.2-.8,4.2-1.9-1.2-1.8-4.4-2.5c-4.4-1-7.2-2.7-7.2-5.3s3.7-5.4,9.9-5.4,5.1.4,6.7.9l-1.3,3.3c-1.1-.3-2.9-.8-5.5-.8s-3.8.8-3.8,1.7,1.5,1.7,4.9,2.5c4.6,1.2,6.8,2.8,6.8,5.4s-3.4,5.6-10.6,5.6-5.9-.6-7.4-1.1l1.2-3.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M55.6,15.7h.2c1,0,1.7.2,2,.7,0,0,0,.1,0,.2,0,.1-.2.2-.5.3,0,0-.2,0-.4,0h-1.5c-.5,0-1,.2-1.5.7-.1.2-.3.3-.4.6.2.3.5.5.9.6.6.2,1.7.5,3.1,1,1.7.6,2.6,1.2,2.6,1.9h0c0,1.1-1.2,1.9-3.7,2.5-.7.2-1.3.2-1.8.2-1.2,0-1.9-.2-2.2-.8,0-.2-.1-.3-.1-.5,0-.5.3-.9.8-1.3.2,0,.4-.2.6-.2,0,0,0,.2,0,.3v.9c.4.1.8.2,1.3.2,1.2,0,2.2-.3,3.2-.9.2-.2.3-.3.4-.4-.3-.3-.6-.6-1-.7-.5-.2-1.6-.6-3.4-1.1-1.5-.5-2.2-1.1-2.2-1.8h0c0-.8.6-1.5,1.7-2.1.6-.3,1.2-.5,1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M62,19.1c.6,0,1.2.4,1.6,1.3,0,.3.1.5.1.6,0,.6-.5,1.1-1.4,1.5h0c.2.4.6.7,1,.7s1.2-.4,1.8-1.4c.4-.4.7-.7.9-.7h0v.2h0c0,.1,0,.1,0,.1,0,0,.1,0,.2-.2h0c0,.2-.2.6-.6,1.1,0,.1,0,.2-.1.4-.2,0-.3,0-.3.2-.3.6-.8,1-1.5,1.2-.2,0-.4,0-.5,0h-.2c-.9,0-1.8-.7-2.7-2h0s0-1.5,0-1.5h0c0-.7.2-1.1.6-1.3.4-.2.8-.3,1.1-.3ZM61.4,20.9c0,.4.1.6.3.8.2,0,.4-.1.7-.3,0-.1,0-.3,0-.4,0-.4-.2-.6-.5-.8h-.2c-.2,0-.3,0-.3.2,0,.1-.1.3-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M68.3,19.6h.1c.6,0,1.1.2,1.4.5,0,0,.1,0,.1.2-.1,0-.2.1-.2.2,0,1.6.1,2.9.1,3.7,0,1.6-.1,2.1-.4,2.6-.4.8-.9,1.1-1.5,1.1s-1.1-.2-1.6-.7h0v-.2c0-.2-.2-.5-.5-.9-.1-.2-.2-.4-.2-.6s0-.3.2-.4h0c0,0,.2,0,.3.2.2,0,.2,0,.2,0,.1.4.4.7.9,1.1,0,0,.2.1.5.3.2,0,.5-.2.6-.5.2-.4.3-.6.3-1.4v-2.3c0,0,0-.4,0-.4-.1.1-.4.5-.9,1.2-.4.4-.7.6-1,.6h-.1c-.2,0-.5-.1-.7-.4-.2-.1-.3-.3-.3-.5,0-.2-.1-.4-.1-.7h0c0-1.2.5-2,1.6-2.5.4-.2.8-.3,1.2-.3ZM66.7,22.4h0c0,.1,0,.5,0,.5.3-.2.6-.5.9-1,.3-.6.6-.9.7-1.2,0,0,0,0,0,0-.3,0-.6.2-1,.5-.3.4-.5.8-.5,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M73.1,20.3h0c.2,0,.4,0,.5.3.1,1.2.3,2.1.5,2.8.2.2.3.4.3.6v.2c0,.1,0,.2-.1.2h-.2c-.5,0-.9-.4-1.1-1.3v-.2c-.7.6-1.1,1-1.3,1.2h-.2c0,0-.2,0-.5.1h0c-.3,0-.4-.3-.5-.9v-.3s0-.2,0-.2c0-.9.2-1.6.6-2.2.1-.2.3-.2.4-.2s.4.1.5.4c0,.2-.1.6-.3,1.3,0,.1,0,.3,0,.5h0c.3,0,.5-.4.8-1,.3-.8.5-1.2.6-1.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M78.5,19.1h0c.4,0,.6,0,.6.3,0,.2.1.3.2.4h0c-1.1.6-1.9,1.5-2.4,2.8-.2.7-.4,1.2-.4,1.6-.4.2-.6.3-.7.3,0-.1-.1-.3-.5-.4,0-.2-.2-1.1-.5-2.5,0-.3-.1-.6-.1-.9v-.3c0-.2.2-.3.6-.3h0c.4,0,.6.3.7.8h0c0,0,0,.3,0,.3.3-.2.7-.7,1.2-1.3.4-.4.9-.6,1.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M81.5,20h0c.6,0,1.1.4,1.3,1.2,0,.2.1.4.1.7v.2c0,.9-.3,1.6-1,2.1-.4.2-.7.3-1,.3h0c-.7,0-1.1-.4-1.4-1.3,0-.2-.1-.4-.1-.7h0c0-.7,0-1.2.2-1.7,0,0,.2-.1.5-.2,0,0,.2-.2.3-.4.2-.1.5-.2,1-.2ZM80.7,21.5v.2s0,.9,0,.9c0,.5.1.8.3.8.3-.1.5-.3.6-.6.1-.2.2-.5.2-.7h0c0-.4-.1-.7-.4-1-.2,0-.4.1-.6.4,0,0-.1.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M85.7,19.4h.1c.4,0,.7.1.7.3,0,.2.1.4.1.4,0,.1-.3.2-.6.3-.9.1-1.3.3-1.3.4.1.2.5.4,1,.6.9.2,1.6.4,2,.6.4.2.6.5.6.9,0,.6-.6,1.1-1.7,1.3-.3,0-.6,0-.9,0-1.1,0-1.7-.2-1.7-.4-.1-.1-.2-.3-.2-.4h0c0-.3.1-.5.4-.8.6.3,1.2.5,1.6.5s.6,0,.9-.3h0c-.4-.2-1-.4-1.9-.6-.9-.3-1.4-.6-1.4-1h0c0-.7.4-1.2,1.2-1.5.4-.2.8-.3,1.1-.3Z"
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "128.3 55.7 116.9 55.7 128.3 47.8 128.3 55.7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrbis);
export default __webpack_public_path__ + "static/media/logo_orbis.bfb3cc545e70cf22803aac567f89933f.svg";
export { ForwardRef as ReactComponent };